import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(({
    dialogContent: {
        minWidth: '300px',
        minHeight: '120px',
    },
    iconButtonContainer: {
        width: '100%',
        position: 'absolute',
        right: 0,
        top: 0,
        display: 'flex',
        justifyContent: 'end',
        background: '#fff',
    },
    title: {
        padding: '12px',
        margin: '20px 0',
        color: 'white',
        background: '#35465c'
    },
    chasisTitle: {
        fontWeight: 'bold'
    },
    emptyMessage: {
        marginBottom: '20px'
    }
}))